import React from "react";
import { Box, Card, Typography } from "@mui/material";

const PetaLokasi = () => {
 return (
    <Box sx={{ width: "100%" }}>
      <Typography
             variant="h4"
             align="center"
             sx={{ fontWeight: 600, my: 4, color: "#113457ff" }}
           >
            Lokasi Terminal
           </Typography>
     

      {/* Container Konten */}
      <Card
        sx={{
          p: 0,
          borderRadius: 3,
          height: "calc(100vh - 180px)", 
          overflow: "hidden",
        }}
      >
        <iframe
          src="https://uptaj.my.id/"
          title="UPT AJ"
          width="100%"
          height="100%"
          style={{
            border: "none",
          }}
        />
      </Card>
    </Box>
  );
};
export default PetaLokasi;
